<template>
  <div class="content">
    <!-- 基本信息 -->
    <div class="content-box content-scheme">
      <div class="pay-info" v-if="Object.keys(schemeInfo).length">
        <!--
          甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
          甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。
          总部为售后服务公司时，售后公司应收的金额 需累计总部应收中
        -->
        <div v-if="contractInfo.isCharge">
          {{$t('crm_contract_scheme_trial.ke_hu_ying_fu')}}：
          <span>{{ schemeInfo.firstTotal }}</span>
        </div>
        <div v-if="contractInfo.isCharge">
          {{$t('crm_contract_scheme_trial.zong_bu_ying_shou')}}：
          <span>{{ schemeInfo.hqProfitTotal }}</span>
        </div>
        <div v-if="contractInfo.isCharge && contractInfo.partyAId !== contractInfo.afterServiceId&& contractInfo.hqId !== contractInfo.afterServiceId">
          <!-- 售后应收/台 合同基本信息中  是否缴费为是 时 且 （ 售后 不等于甲方代表  且 售后公司不等于 总部）时 显示 -->
          {{$t('crm_contract_scheme_trial.shou_hou_ying_shou')}}：
          <span>{{ schemeInfo.serviceProfitTotal }}</span>
        </div>
        <div v-if="contractInfo.isCharge && contractInfo.partyAId !==contractInfo.hqId">
          <!-- 甲方代表应收/台 合同基本信息中  是否缴费为是 时  甲方代表不等于总部 显示，  甲方=总部时  不显示，甲方授权代表金额 =客户应付 - 总部应收 - 售后应收 -->
          {{$t('crm_contract_scheme_trial.jfdbys')}}：
          <span>{{ schemeInfo.agentCoProfitTotal }}</span>
        </div>
      </div>
      <div class="supplies-box">
        <div class="table-bd">
          <custom-table
            tableCode="contract_scheme_trial"
            :max-height="500"
            :data="leaseForm.goodsList"
            :index="true"
            @filter="filterChange"
            @sort="sortChange"
            @column="setColumn"
            :filterArr="filterArr"
            :slots="['productCode', 'deviceBizType', 'bookingNum', 'hqDeliveryNum', 'rentalTerm', 'hqShipTo','action','unitPrice','hqProfit','afterServiceProfit','agentCoProfit' ]"
          >
            <template v-slot:productCode="scope">
              <custom-select
                v-model="scope.row.productCode"
                url="productCodeSelectList"
                :props="{ label: 'productName', value: 'productCode' }"
                :placeholder="$t('Common.com_please_select')"
                filterable
                remote
                clearable
                reserveKeyword
                width="100%"
              ></custom-select>
            </template>
            <template v-slot:deviceBizType="scope">
              <custom-select
                v-model="scope.row.deviceBizType"
                code="dms_device_biz_type"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </template>
            <template v-slot:bookingNum="scope">
              <el-input
                v-model.number="scope.row.bookingNum"
              ></el-input>
            </template>
            <template v-slot:hqDeliveryNum="scope">
              <el-input
                v-model.number="scope.row.hqDeliveryNum"
              ></el-input>
            </template>
            <template v-slot:rentalTerm="scope">
              <el-input
                v-model="scope.row.rentalTerm"
                type="number"
                :min="0"
              ></el-input>
            </template>
            <template v-slot:unitPrice="scope">
              <el-input
                v-model="scope.row.unitPrice"
                type="number"
                :min="0"
              ></el-input>
            </template>
            <template v-slot:hqProfit="scope">
              <el-input
                v-model="scope.row.hqProfit"
                type="number"
                :min="0"
              ></el-input>
            </template>
            <template v-slot:afterServiceProfit="scope">
              <el-input
                v-model="scope.row.afterServiceProfit"
                type="number"
                :min="0"
              ></el-input>
            </template>
            <template v-slot:agentCoProfit="scope">
              <span>{{ (scope.row.unitPrice- scope.row.hqProfit - scope.row.afterServiceProfit).toFixed(2) }}</span>
              <!-- <el-input
                v-model="scope.row.agentCoProfit"
                type="number"
                :min="0"
              ></el-input> -->
            </template>
            <template v-slot:hqShipTo="scope">
              <custom-select
                disabled
                v-model="scope.row.hqShipTo"
                code="crm_receiving_party"
                :placeholder="$t('Common.com_please_select')"
                width="100%"
              ></custom-select>
            </template>

              <template v-slot:action="scope">
                <el-button
                  type="text"
                  size="mini"
                  @click="saveScheme(false,false)"
                >{{ $t('Common.com_save') }}</el-button>
                <el-button
                  type="text"
                  size="mini"
                  @click="deleteStuffItem(scope.$index, scope.row)"
                >{{ $t('Common.com_delete') }}</el-button>

                <!-- <div class="icon-box" @click="deleteStuffItem(scope.$index)">
                  <i class="icon icon-shanchu"></i>
                </div> -->
              </template>
          </custom-table>
        </div>
        <div class="lease-add-btn" @click="addStuffItem">
          <div style="display: inline-block">
            <i class="icon icon-add"></i>
            <span>{{ $t('Common.com_added') }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="btn-group">
      <el-button @click="onCancel">{{$t('Common.com_cancel')}}</el-button>
      <el-button @click="preStep">{{
        $t('crm_contract_scheme_trial.sybhtxx')
      }}</el-button>
      <!--
        saveScheme
        第一个参数是 保存草稿还是提交
        第二个参数是 保存不下一步  为了查看的分账
       -->
      <el-button type="primary" @click="saveScheme(true,true)">{{
        $t('crm_contract_scheme_trial.bao_cun_ti_jiao')
      }}</el-button>
      <el-button type="primary" @click="saveScheme(false,true)">{{
        $t('crm_contract_scheme_trial.bao_cun_cao_gao')
      }}</el-button>
    </div>

  </div>
</template>

<script>
import apis from '@/utils/apis';

export default {
  props: {
    contractId: [String, Number],
    operateFlag: [String],
  },
  inject: ['getContractInfo'],
  computed: {
    contractInfo() {
      return this.getContractInfo();
    },
    filterArr() {
      let arr = [];
      // <!--
      //     甲方代表 总部一样 显示总部应收  显示 总部应收，金额取 甲方授权代表应收金额
      //     甲方代表 售后一样 显示甲方代表应收 显示甲方授权代表应收 金额取 甲方授权代表应收。
      //     总部为售后服务公司时，售后公司应收的金额 需累计总部应收中
      //   -->
      if (!this.contractInfo.isCharge) {
        arr = ['unitPrice', 'hqProfit', 'afterServiceProfit', 'agentCoProfit'];
      }
      if (this.contractInfo.isCharge) {
        if (!(this.contractInfo.partyAId !== this.contractInfo.afterServiceId && this.contractInfo.hqId !== this.contractInfo.afterServiceId)) {
          arr.push('afterServiceProfit');
        }
        if (this.contractInfo.partyAId === this.contractInfo.hqId) {
          arr.push('agentCoProfit');
        }
      }

      return arr;
    },
  },
  data() {
    return {
      // tableCode: 'contract_scheme_trial',
      // 租赁方案
      leaseForm: {
        goodsList: [],
        // 删除的
        deleteList: [],
      },
      goodsItem: {
        // 订购数量
        bookingNum: 0,
        // 总部需发
        hqDeliveryNum: 0,
        // 发货方默认是乙方
        hqShipTo: '2',

        // 订单商品Id，编辑时必填
        orderGoodsId: '',
        // 产品型号
        productCode: '',
        // 租期(试用天数)
        rentalTerm: 0,
        // 设备类型
        deviceBizType: '',

        unitPrice: 0, // 客户应付/台
        hqProfit: 0, // 总部应收/台
        afterServiceProfit: 0, // 售后公司应收/台
        agentCoProfit: 0, // 甲方代表应收/台
      },
      schemeInfo: {},

    };
  },
  mounted() {
    // this.factoryId = this.getJump('factoryId');
    // this.contractId = this.contractId || '';

    // this.getTableColumn();
    this.getCompanyDetail();
  },
  methods: {
    getCompanyDetail: function () {
      if (!this.contractId) {
        return;
      }
      this.$getJSON(apis.trialOrderListScheme, {
        bizId: this.contractId,
      }).then((res) => {
        const data = res.data;
        data.goodsList.forEach((i) => {
          i.hqShipTo = `${i.hqShipTo}` || '2';
          // 变更了第一步有可能值需要置为0
          for (const key in this.filterArr) {
            i[this.filterArr[key]] = 0;
          }
        });
        this.leaseForm.goodsList = data.goodsList;
        this.schemeInfo = res.data;
      });
    },

    // 甲方代表应收/台
    // onAgentCoProfit(row) {
    //   row.agentCoProfit = (row.unitPrice - row.hqProfit - row.afterServiceProfit).toFixed(2);
    // },
    // 租赁方案
    saveScheme: function (isStartApprove, flag) {
      // 选择方案
      const planLength = this.leaseForm.goodsList.length;
      if (planLength <= '0') {
        this.$message.error(
          this.$t('crm_contract_scheme_trial.qing_xuan_ze_she_bei')
        );
        return;
      }
      // 表单验证
      const hasEmpty = this.leaseForm.goodsList.find(
        t => !t.productCode || t.deviceBizType === '' || t.bookingNum === '' || t.hqDeliveryNum === '' || t.hqShipTo === '' || t.rentalTerm === '' || t.unitPrice === '' || t.hqProfit === '' || t.afterServiceProfit === '' || t.agentCoProfit === ''
      );
      if (hasEmpty) {
        this.$message.error(this.$t('crm_contract_scheme_trial.qjsblbtxwz'));
        return;
      }
      const negativeTotal = this.leaseForm.goodsList.find(
        t => +t.bookingNum <= 0
      );
      if (negativeTotal) {
        this.$message.error(this.$t('crm_contract_scheme_trial.dgslbnxy0'));
        return;
      }
      const negativeShip = this.leaseForm.goodsList.find(
        t => +t.hqDeliveryNum < 0
      );
      if (negativeShip) {
        this.$message.error(this.$t('crm_contract_scheme_trial.zbxfslbnxy0'));
        return;
      }
      const sumProfit = this.leaseForm.goodsList.find(
        t => +t.unitPrice < 0 || +t.hqProfit < 0 || +t.afterServiceProfit < 0
      );
      if (sumProfit) {
        this.$message.error(this.$t('crm_contract_scheme_trial.ysyfjebnxy0'));
        return;
      }
      const hqDeliveryNumBigger = this.leaseForm.goodsList.find(
        t => +t.bookingNum < +t.hqDeliveryNum
      );
      if (hqDeliveryNumBigger) {
        this.$message.error(this.$t('crm_contract_scheme_trial.zbfhbxxydgsl'));
        return;
      }

      const rentalTermShip = this.leaseForm.goodsList.find(
        t => +t.rentalTerm <= 0
      );
      if (rentalTermShip) {
        this.$message.error(this.$t('crm_contract_scheme_trial.sytsbnxy0'));
        return;
      }
      // this.leaseForm.goodsList.forEach(i => i.agentCoProfit = (i.unitPrice - i.hqProfit - i.afterServiceProfit).toFixed(2));
      this.leaseForm.goodsList.forEach((item) => {
        item.agentCoProfit = (item.unitPrice - item.hqProfit - item.afterServiceProfit).toFixed(2);
        // if (this.contractInfo.partyAId === this.contractInfo.hqId) {
        //   item.afterServiceProfit = item.unitPrice;
        // }
      });
      // 保存更改租赁方案
      this.$postJSON(apis.trialOrderSaveScheme, {
        bizId: this.contractId,
        operateFlag: this.operateFlag,
        goodsList: [...this.leaseForm.goodsList, ...this.leaseForm.deleteList],
        isStartApprove
      }).then(() => {
        if (flag) {
          this.$message({
            message: this.$t('Common.com_save_success'),
            type: 'success',
          });
          // 上传纸质合同
          this.$emit('successJump');
        } else {
          // 清空
          this.leaseForm.deleteList = [];
          this.getCompanyDetail();
        }


      });
    },
    // 保存草稿
    saveDraft: function () {
      this.$message({
        message: this.$t('Common.com_save_success'),
        type: 'success',
      });
      this.$emit('successJump');
    },

    // 添加耗材项
    addStuffItem: function () {
      // this.leaseForm.stuffList.push(this.stuffitem);
      this.leaseForm.goodsList.push(JSON.parse(JSON.stringify(this.goodsItem)));
    },
    // 删除方案项
    deleteStuffItem: function (index, row) {
      this.leaseForm.goodsList.splice(index, 1);
      // 完整的数据才传参
      if (!(!row.productCode || row.deviceBizType === '' || row.bookingNum === '' || row.hqDeliveryNum === '' || row.hqShipTo === '' || row.rentalTerm === '' || row.unitPrice === '' || row.hqProfit === '' || row.afterServiceProfit === '' || row.agentCoProfit === '')) {
        this.leaseForm.deleteList.push({ ...row, isDeleted: true });
      }
      if (this.leaseForm.goodsList.length < 1) {
        this.schemeInfo = {};
      }
    },
    // 取消
    onCancel: function () {
      this.$emit('cancelJump');
    },
    preStep: function () {
      this.$emit('previous');
    },
  },
};
</script>

<style lang="scss">
@import "@/style/colors.scss";
.content-scheme {
  padding: 14px 24px 0;
  .pay-info {
    display: flex;
    justify-content: flex-end;
    line-height: 36px;
    color: #495057;
    font-size: 12px;
    font-weight: 500;
    margin-top: 10px;
    & > div {
      margin-left: 20px;
      margin-right: 10px;
      span {
        color: red;
        font-size: 14px;
      }
    }
  }
  table {
    border-collapse: collapse;
  }
  .el-table .cell {
    // color: #FFFFFF;

    color: rgba(57, 70, 104, 1);
  }
  .el-table .el-table__row td {
    // display: inline-block;
    // width: 100%;
    margin-top: 16px;
    // background: #f5f5fa;
    color: rgba(57, 70, 104, 1);
    border: 0 !important;
  }
  .el-table tr {
    // background: #f5f5fa;
    border: 1px solid #f2f3fb;
    color: rgba(57, 70, 104, 1);
    th .cell {
      color: #636e78;
    }
  }
  .el-table__expanded-cell[class*="cell"] {
    padding: 0;
  }
  .tab-wrap {
    // padding: 0 24px;
    .wrap-form {
      background: #ffffff;
      padding: 10px 24px 0;
      .wrap-form-row {
        background: #ffffff;
        padding: 10px 14px 0;
        background: #f8f9fb;
      }
    }
    .rent-amount {
      background: #ffffff;
      padding: 0 8px;
      display: flex;
      li {
        width: 100px;
        margin: 20px 16px 12px;
        border-right: 1px solid rgba(0, 0, 0, 0.05);
        height: 50px;
        .title {
          height: 16px;
          font-size: 12px;
          font-weight: bold;
          color: #495057;
          line-height: 16px;
        }
        .amount {
          margin-top: 6px;
          height: 28px;
          font-size: 12px;
          font-weight: bold;
          color: #0d9ae0;
          line-height: 28px;
        }
        &:last-of-type {
          border: 0;
        }
      }
    }
  }

  .lease-add-btn {
    line-height: 50px;
    text-align: center;
    color: rgba(73, 80, 87, 1);
    font-size: 12px;
    margin: 16px 0 16px;
    height: 50px;
    background: #f6f7fb;
    border: 1px dashed rgba(53, 184, 224, 0.3);
    cursor: pointer;
    span {
      line-height: 50px;
    }
    .icon {
      color: #00afff;
      font-size: 12px;
      margin-right: 8px;
      display: inline-block;
      line-height: 50px;
      height: 50px;
      // float: left;
    }
  }


  // .rule-action-bd {
  .supplies-list{
    ul li {
      margin-top: 10px;
      margin-bottom: 10px;
      // border: 1px solid rgba(228, 228, 228, 1);
      &:first-child {
        margin-top: 0;
      }
    }
    .formContact-title {
      // height: 30px;
      // line-height: 30px;
      background: rgba(228, 228, 228, 1);
      color: #636E78;
      font-size: 12px;
      // padding: 0 10px;
    }
    .item {
      padding: 10px;
      background: rgba(245, 245, 245, 1);
      border: 1px solid rgba(228, 228, 228, 1);
      .index,.code{
        line-height: 32px;
        height: 32px;
        color: #6C757D;
        width: 100%;
      }

      .icon-box {
        line-height: 32px;
        width: 32px;
        // margin-left: 10px;
        text-align: center;
        .icon {
          color: #00afff;
          font-size: 14px;
          cursor: pointer;
        }
      }
    }

  }
  .add-child-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 30px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin: 0 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }
  .role-add-btn {
    background: rgba(245, 245, 245, 1);
    border: 1px dashed rgba(228, 228, 228, 1);
    line-height: 40px;
    text-align: center;
    color: #333333;
    font-size: 12px;
    margin-top: 10px;
    cursor: pointer;
    .icon {
      color: #00afff;
      font-size: 10px;
      margin-right: 8px;
      float: left;
    }
  }

}
</style>
